import React from "react";
import { jt, t } from "ttag";

import { Link } from "../../../common/Link";
import { IWebPageURL } from "../../../models/nominals";
import { formatPhoneNumber } from "../../../utils/format";
import { UnifiedOrderLookupShippingAddress } from "../types";

import defaultStyles from "./index.module.scss";

interface TrackShipmentDetailsCustomerInfoProps {
    shippingAddress: UnifiedOrderLookupShippingAddress;
    customerLoginURL: IWebPageURL;
    customerRegisterURL: IWebPageURL;
    customStyles?: CSSModuleClasses;
}

export const TrackShipmentDetailsCustomerInfo: React.FC<
    TrackShipmentDetailsCustomerInfoProps
> = ({
    shippingAddress,
    customerLoginURL,
    customerRegisterURL,
    customStyles,
}) => {
    const isRedacted = shippingAddress.line1 === "XXXXX";
    const styles = customStyles || defaultStyles;
    const loginLink = (
        <Link className={styles.link} href={customerLoginURL}>
            {t`Login`}
        </Link>
    );
    const signUpLink = (
        <Link className={styles.link} href={customerRegisterURL}>
            {t`Create one`}
        </Link>
    );

    return (
        <div>
            <h3 className={styles.title}>{t`Delivery Information`}</h3>
            {isRedacted ? (
                <div>
                    <p className={styles.copy}>
                        {jt`${loginLink} to view your delivery address, payment information, and order history.`}
                    </p>
                    <p className={styles.copy}>
                        {jt`Don't have an account? ${signUpLink}`}
                    </p>
                </div>
            ) : (
                <address className={styles.address}>
                    <div>
                        {shippingAddress.line1} {shippingAddress.line2}
                    </div>
                    <div>
                        {shippingAddress.line3} {shippingAddress.line4}
                        {", "}
                        {shippingAddress.state}
                    </div>
                    <div>
                        {shippingAddress.postcode}
                        {", "}
                        {shippingAddress.country}
                    </div>
                </address>
            )}
            <p className={styles.copy}>
                {formatPhoneNumber(shippingAddress.phone_number)}
            </p>
        </div>
    );
};
